// extracted by mini-css-extract-plugin
export default {"container":"I1bXs9txdQvYa+27NFNlDw==","lottie":"CWGYUiYDdUUWjxHeABTwsg==","button":"BGeKw015BvbUls07IjvDag=="};